import type { TableOfContentsItem } from './tableOfContentsTypes.ts';

export type RelativeHeadingIndentation = 0 | 1 | 2 | 3 | 4 | 5;

function countActiveHeadingLevels(
	activeHeadingLevels: readonly boolean[],
	currentHeadingLevel: TableOfContentsItem['level'],
): RelativeHeadingIndentation {
	return (Number(currentHeadingLevel > 1 && activeHeadingLevels[0]) +
		Number(currentHeadingLevel > 2 && activeHeadingLevels[1]) +
		Number(currentHeadingLevel > 3 && activeHeadingLevels[2]) +
		Number(currentHeadingLevel > 4 && activeHeadingLevels[3]) +
		Number(currentHeadingLevel > 5 && activeHeadingLevels[4])) as RelativeHeadingIndentation;
}

/**
 * Derives the visual hierarchy from document order rather than from absolute
 * heading numbers. A heading only gains an indent for an active, higher-level
 * heading that precedes it in the same section.
 */
export function getRelativeHeadingIndentation(
	items: TableOfContentsItem[],
): RelativeHeadingIndentation[] {
	const activeHeadingLevels = Array<boolean>(6).fill(false);

	return items.map((item) => {
		const indentation = countActiveHeadingLevels(activeHeadingLevels, item.level);

		// Keep preceding higher-level headings as ancestors, replace the current
		// level, and discard all lower-level headings from the previous section.
		activeHeadingLevels.fill(false, item.level - 1);
		activeHeadingLevels[item.level - 1] = true;

		return indentation;
	});
}
